import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/gestion/reservas")({
  component: ReservasLayout,
});

function ReservasLayout() {
  return <Outlet />;
}